module.exports = __webpack_public_path__ + "static/media/Live2.ab9dd59.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/liveroadcast/Live2.mp4
// module id = 0Teu
// module chunks = 1